<style lang="scss">
  @import 'index.scss';
</style>
<template>
  <div class="associative-search" v-clickoutside="handleClose">
    <Input
      class="associative-search-input"
      icon="ios-search"
      :placeholder="$t('common.search')"
      v-model="searchValue"
      @on-click="oncertain"
      @on-enter="oncertain"
      @on-change="search"
      @on-focus="opshow = true"
    >
    </Input>
    <div class="oplist-box" v-if="opshow && showList.length > 0">
      <ul class="oplist" v-if="showList.length > 0">
        <li v-show="opnoData">{{$t('common.nodata')}}</li>
        <li v-for="(item, index) in showList" :key="index" >
          <span @click="selectQuery(item)" :title="item" style="width: 92%; display: inline-block;text-overflow:ellipsis;overflow:hidden;">{{item}}</span>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>

import { directive as clickoutside } from 'v-click-outside-x';

export default {
  props: {
    // 输入框内容
    value: {
      type: String,
      default: '',
    },
    // 按keyName为key进行检索匹配
    keyname: {
      type: Array,
      default: [],
    },
    // 表格相关数据
    optionlist: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  directives: {
    clickoutside,
  },
  components: {},
  data() {
    return {
      // 控制匹配列表显示
      opshow: false,
      // 控制无匹配数据显示
      opnoData: false,
      showList: [],
      searchValue: this.value,
      testvalue: '',
    };
  },
  created() {

  },
  computed: {
  },
  methods: {
    search() {
      this.showList = [];
      if (this.searchValue === '') {
        this.showList = [];
        return;
      }
      const searchValue = this.searchValue.toLowerCase();
      const key = this.keyname;
      const list = this.optionlist;
      const result = [];

      list.forEach((v) => {
        if (v[key[0]] && v[key[1]]) {
          if (v[key[0]].toLowerCase().indexOf(searchValue) > -1) {
            result.push(v[key[0]]);
          } else if (v[key[1]].toLowerCase().indexOf(searchValue) > -1) {
            result.push(v[key[1]]);
          }
        } else if (v[key[0]] && !v[key[1]]) {
          if (v[key[0]].indexOf(searchValue) > -1) result.push(v[key[0]]);
        } else if (!v[key[0]] && v[key[1]]) {
          if (v[key[1]].indexOf(searchValue) > -1) result.push(v[key[1]]);
        }
      });
      this.opshow = result.length > 0;
      // this.opnoData = result.length <= 0;
      this.showList = result;
    },
    oncertain() {
      this.$emit('associative-search', this.searchValue);
    },
    selectQuery(data) {
      this.searchValue = data;
      this.opshow = false;
      this.$emit('associative-search', this.searchValue);
    },
    handleClose() {
      this.opshow = false;
    },
  },
  watch: {
  },
  mounted() {

  },
  beforeDestroy() {},
};
</script>
